import React, { useRef } from "react";
import styles from "./ResizableTable.module.css";
import { FaGripLinesVertical } from "react-icons/fa";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const ResizableTh = ({ children, className = "" }: Props) => {
  const thRef = useRef<HTMLTableCellElement>(null);

  const onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const startX = e.pageX;
    const startWidth = thRef.current?.offsetWidth || 0;

    const onMouseMove = (e: MouseEvent) => {
      const newWidth = startWidth + (e.pageX - startX);
      if (thRef.current) thRef.current.style.width = `${newWidth}px`;
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <th ref={thRef} className={className}>
      <div className={styles.resizableHeader}>
        {children}
        <div className={styles.resizer} onMouseDown={onMouseDown}></div><FaGripLinesVertical className={`${styles.resizerIcon} ${styles.sortIconDisabled}`} />
      </div>
    </th>
  );
};

export default ResizableTh;